<template>
  <Row>
    <Col class="mt-5" cols="12">
      <PanelHeading
        :title="this.lc.title"
        :subtitle="this.greetingText"
        :description="this.lc.description"
        header
        headerColor="gray"
        wave
      />
    </Col>
    <Col cols="12">
      <ImprovementAlert />
    </Col>
    <Col cols="12">
      <Row>
        <Col md="12">
          <EditSiteCard />
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import { Row, Col } from '@locaweb/design-system-vue'
import PanelHeading from '@/components/PanelHeading.vue'
import { authStore } from '@/store/auth'
import EditSiteCard from '../components/EditSiteCard.vue'
import ImprovementAlert from '../components/ImprovementAlert.vue'

export default {
  name: 'WelcomeView',
  components: {
    Row,
    Col,
    PanelHeading,
    EditSiteCard,
    ImprovementAlert
  },
  computed: {
    lc () {
      return this.$lc('site.welcome')
    },
    username () {
      return authStore().userName
    },
    greetingText () {
      return this.lc.greetingText.replaceValues({ user: this.username })
    }
  }
}
</script>
